import React from 'react';
import { JobCostInsight } from '../usage/JobCostInsight';
import { adminAPI } from '../../lib/api';

export function AiCostPerHireTab() {
  return (
    <JobCostInsight
      getReport={(month) => adminAPI.getAiUsageByJob(month)}
      showCompany
      intro="Average AI credits it takes to move one candidate from resume upload to hire, per job — across all companies. Avg credits / hire = total AI credits spent on the job ÷ candidates hired."
    />
  );
}
